import { render, staticRenderFns } from "./question-create.vue?vue&type=template&id=20e25ab2&scoped=true&"
import script from "./question-create.vue?vue&type=script&lang=js&"
export * from "./question-create.vue?vue&type=script&lang=js&"
import style0 from "./question-create.vue?vue&type=style&index=0&id=20e25ab2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e25ab2",
  null
  
)

export default component.exports